// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__8vCsq","summary":"CartItem_summary__HDJ86","price":"CartItem_price__Mw0Es","amount":"CartItem_amount__fFHxE","actions":"CartItem_actions__DVAFr"};